import { OrdersSalesQueryKeys } from '@enums/react-query-keys';
import { ShippingAddress } from '@interfaces/api/responses/user-shipping-address';
import { getShippingAddresses } from '@services/my-orders-sales-service';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

const useGetShippingAddresses = (enabled?: boolean) => {
  const [selectedAddress, setSelectedAddress] = useState<ShippingAddress>();

  const query = useQuery({
    queryKey: [OrdersSalesQueryKeys.GET_SHIPPING_ADDRESS],
    queryFn: () => getShippingAddresses(),
    staleTime: 10 * 60 * 1000, // 10 min
    enabled,
  });

  useEffect(() => {
    if (!query.data || !query.data.length) {
      return;
    }
    const addressItem = query.data.find((a) => a.isSelected) || query.data[0];
    setSelectedAddress(addressItem.address);
  }, [query.data]);

  return { ...query, selectedAddress };
};

export default useGetShippingAddresses;
